import { Team } from "@brg/api";
import { FlexBox } from "@brg/ui";
import { LayoutConst } from "core";
import { FC, useMemo } from "react";
import { ModerationTypeShortNames } from "shared/pages/teams/const/ModerationTypes";
import styled from "styled-components";

export const LabelWrapper = styled(FlexBox)`
    height: 100%;
    align-self: flex-end;
    display: inline-flex;
`;

export const Label = styled.span`
    display: inline-block;
    color: #909090;
    font-size: 30px;
    line-height: 60px;
    margin-left: 8px;
    text-transform: lowercase;

    @media(max-width: ${LayoutConst.screen.l_12}px) {
        font-size: 17px;
        line-height: 44px;
    }
`;

export const TeamLabel: FC<{ team: Team}> = ({ team }) => {
    //@ts-ignore
    const moderationType = useMemo(() => (team?.moderationType) , [team]) as number;

    //@ts-ignore
    const moderationTypeString = useMemo(() =>(ModerationTypeShortNames[moderationType as number]) , [moderationType])

    if (!moderationType) {
        return null;
    }
    
    return (
        <LabelWrapper>
            <Label>{moderationTypeString}</Label>
        </LabelWrapper>
    )
}import { Team } from "@brg/api";
import { FlexBox } from "@brg/ui";
import { LayoutConst } from "core";
import { FC, useMemo } from "react";
import { ModerationTypeShortNames } from "shared/pages/teams/const/ModerationTypes";
import styled from "styled-components";

export const LabelWrapper = styled(FlexBox)`
    height: 100%;
    align-self: flex-end;
    display: inline-flex;
`;

export const Label = styled.span`
    display: inline-block;
    color: #909090;
    font-size: 30px;
    line-height: 60px;
    margin-left: 8px;
    text-transform: lowercase;

    @media(max-width: ${LayoutConst.screen.l_12}px) {
        font-size: 17px;
        line-height: 44px;
    }
`;

export const TeamLabel: FC<{ team: Team}> = ({ team }) => {
    //@ts-ignore
    const moderationType = useMemo(() => (team?.moderationType) , [team]) as number;

    //@ts-ignore
    const moderationTypeString = useMemo(() =>(ModerationTypeShortNames[moderationType as number]) , [moderationType])

    if (!moderationType) {
        return null;
    }
    
    return (
        <LabelWrapper>
            <Label>{moderationTypeString}</Label>
        </LabelWrapper>
    )
}